import * as React from 'react'

import { Text, TextName } from 'sdk'
import { OutlineGlassBackgroundCard } from 'components/outline-glass-background-card/OutlineGlassBackgroundCard'
import latencyIcon from 'shared/assets/icons/latency.svg'
import settingsIcon from 'shared/assets/icons/settings.svg'
import codingIcon from 'shared/assets/icons/coding.svg'
import stopwatchIcon from 'shared/assets/icons/stopwatch.svg'
import crossPlatformIcon from 'shared/assets/icons/cross-platform.svg'
import gpuIcon from 'shared/assets/icons/gpu.svg'

import type { SoundscapePerformanceSpecsCmsContent } from 'core/services/cms/interfaces'

import classes from './style.module.scss'

const SPEC_ICONS = [latencyIcon, settingsIcon, codingIcon, stopwatchIcon, crossPlatformIcon, gpuIcon]

interface PerformanceSpecsProps {
  content: SoundscapePerformanceSpecsCmsContent
}

export const PerformanceSpecs: React.FC<PerformanceSpecsProps> = ({ content }) => {
  const renderDescription = (description: string): React.ReactNode => {
    const boldParts = [
      'Real-time',
      'Massively parallel processing:',
      'previously limited to offline processing',
      '10-second impulse responses',
      'Cross-platform deployment',
      'computationally expensive research-grade DSP',
    ]

    let parts: { text: string; bold: boolean }[] = [{ text: description, bold: false }]

    boldParts.forEach((boldPart) => {
      const newParts: { text: string; bold: boolean }[] = []
      parts.forEach((part) => {
        if (part.bold) {
          newParts.push(part)
        } else {
          const index = part.text.indexOf(boldPart)
          if (index === -1) {
            newParts.push(part)
          } else {
            if (index > 0) {
              newParts.push({ text: part.text.substring(0, index), bold: false })
            }
            newParts.push({ text: boldPart, bold: true })
            if (index + boldPart.length < part.text.length) {
              newParts.push({ text: part.text.substring(index + boldPart.length), bold: false })
            }
          }
        }
      })
      parts = newParts
    })

    return (
      <>
        {parts.map((part, index) => (
          part.bold? (
            <Text key={index} type={TextName.TextBold}>{part.text}</Text>
          ) : (
            <Text key={index} type={TextName.Text}>{part.text}</Text>
          )
        ))}
      </>
    )
  }

  return (
    <section className={classes.content}>
      <Text type={TextName.H2} className={classes.title}>
        {content.title}
      </Text>

      <div className={classes.specs}>
        {content.cards.map((spec, index) => (
          <OutlineGlassBackgroundCard key={index} className={classes.card}>
            <img src={SPEC_ICONS[index]} alt="" className={classes.icon} />
            <div className={classes.description}>{renderDescription(spec.body)}</div>
          </OutlineGlassBackgroundCard>
        ))}
      </div>
    </section>
  )
}
